import type { FC } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { Loader } from '../../loader/Loader';

import styles from './HelpErrorMessage.module.css';

interface HelpErrorMessageProps {
  isError: boolean;
  isConfigError?: boolean;
  onClick?: () => void;
}

export const HelpErrorMessage: FC<HelpErrorMessageProps> = ({ isError, isConfigError, onClick }) => {
  if (isConfigError) {
    console.warn('[Translation] Help files are not configured!');
  }

  return (
    <>
      {isError ? (
        <div className={styles.help__content_error}>
          <h1>
            <L10nText tk="ERROR_TITLE" />
          </h1>
          <p>
            <L10nText tk="ERROR_TEXT" />
          </p>
          <Button tk="RELOAD" variant={ButtonVariant.MAIN} loading={false} onClick={onClick} />
        </div>
      ) : (
        <div className={styles.help__content_loader}>
          <Loader />
        </div>
      )}
    </>
  );
};
